import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-primary-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">热门话题</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">共9个话题 · 实时热度更新</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {topicsData.slice(0, 5).map((item, index) => (
            <div
              key={index}
              className={`group rounded-xl p-4 md:p-5 border cursor-pointer transition-all ${
                item.hot
                  ? 'bg-background-50 border-primary-200 hover:border-primary-300 hover:bg-primary-50/30'
                  : 'bg-background-50 border-background-200/70 hover:border-foreground-200 hover:bg-background-100'
              }`}
            >
              <div className="flex items-center gap-2 mb-2">
                <span className={`w-2 h-2 rounded-full shrink-0 ${item.hot ? 'bg-primary-500' : 'bg-secondary-400'}`} />
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.tag}
                </span>
                {item.hot && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-100 text-primary-600 font-medium">热</span>
                )}
              </div>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <p className="text-[11px] text-foreground-400">{item.heat}</p>
            </div>
          ))}

          {topicsData.slice(5, 9).map((item, index) => (
            <div
              key={index + 5}
              className={`group rounded-xl p-4 md:p-5 border cursor-pointer transition-all ${
                item.hot
                  ? 'lg:col-span-1 bg-background-50 border-primary-200 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/70 hover:border-foreground-200 hover:bg-background-100'
              }`}
            >
              <div className="flex items-center gap-2 mb-2">
                <span className={`w-2 h-2 rounded-full shrink-0 ${item.hot ? 'bg-primary-500' : 'bg-secondary-400'}`} />
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.tag}
                </span>
              </div>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <p className="text-[11px] text-foreground-400">{item.heat}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}